// AR
export const accomMgmt = {
  common: {
    cancel: "إلغاء",
    save: "حفظ",
    update: "تحديث",
    back: "رجوع",
    continue: "متابعة",
    optional: "(اختياري)",
    optionalPlaceholder: "اختياري",
    processing: "جارٍ المعالجة...",
    name: "الاسم",
    description: "الوصف",
    nameRequired: "الاسم مطلوب.",
  },

  type: {
    apartment: "شقة سياحية",
    hotel: "فندق",
    camping: "مخيّم",
    villa: "فيلا",
  },

  step: {
    type: "النوع",
    structure: "الهيكل",
    accommodation: "مكان الإقامة",
  },

  step1: {
    title: "ما نوع مكان الإقامة الذي تملكه؟",
    subtitle: "اختر نوع مكان الإقامة.",
    subtitleQuota: "لن تظهر مفعّلة إلا الأنواع التي لديها حصة متاحة في خطتك.",
    subtitleFirst: "بما أنه أول مكان إقامة لك، يمكنك اختيار أي نوع.",
    remaining: "المتبقّي: {count}",
    loadingQuota: "جارٍ تحميل حصص خطتك…",
  },

  step2: {
    title: "اضبط مكان إقامتك",
    subtitle:
      "حدّد ما إذا كان مكان إقامة مستقلاً أم مكان إقامة بعدة تقويمات (عدة وحدات ضمن مكان إقامة واحد).",
    singleTitle: "مساحة واحدة",
    singleChip: "تقويم واحد",
    singleDesc: "أجّر الشقة بالكامل باستخدام تقويم واحد.",
    groupedTitle: "عدة مساحات",
    groupedChip: "عدة تقويمات",
    groupedDesc: "تؤجّر عدة مساحات مستقلة داخل الشقة",
  },

  step3: {
    title: "اضبط مكان الإقامة الرئيسي",
    subtitle:
      "ستكون هذه «الحاوية» (Listing) التي تجمّع عدة تقويمات. مثال: «سويت القلعة».",
    panelTitle: "اختر خياراً",
    availableCount: "لديك {count} أماكن إقامة مجمّعة متاحة.",
    noneAvailable: "لا توجد إعلانات مجمّعة متاحة لهذا النوع (أنشئ واحداً جديداً).",
    newTitle: "إنشاء مكان إقامة رئيسي جديد",
    newDesc: "أنت تحدّد اسم مكان الإقامة الرئيسي.",
    nameLabel: "اسم مكان الإقامة الرئيسي",
    namePlaceholder: "مثال: سويت القلعة",
    nameHelp: "سيُحفظ هذا الاسم وستتمكّن من تجميع عدة تقويمات.",
    minChars: "اكتب 3 أحرف على الأقل.",
    existingTitle: "إضافة إلى مكان إقامة موجود",
    existingDesc: "ستكون الوحدة ضمن مكان إقامة أنشأته من قبل.",
    selectLabel: "اختر مكان الإقامة",
    selectPlaceholder: "اختر مكان إقامة…",
    listingOption: "{name} · {units} وحدة",
    ready: "جاهز",
    noneForType: "ليس لديك أماكن إقامة مجمّعة متاحة لهذا النوع.",
    tip: "نصيحة: هذا «الرئيسي» سيكون الحاوية التي تُضاف إليها الوحدة الجديدة.",
  },

  preview: {
    tab: "إقامتك",
    perNight: "/الليلة",
    book: "احجز",
    locationPlaceholder: "الدولة، المدينة، الشارع",
    guests: "{count} نزيل | {count} نزلاء",
    bedrooms: "{count} غرفة | {count} غرف",
    bathrooms: "{count} حمّام | {count} حمّامات",
    amenitiesTitle: "الخدمات",
    amenitiesEmpty: "اختر لإضافة خدمات إلى مكان إقامتك",
    locationTitle: "الموقع",
    locationEmpty: "حدّد الموقع",
    descriptionTitle: "الوصف",
    descriptionEmpty: "اختر لإضافة وصف إلى مكان إقامتك",
    namePlaceholder: "اسم مكان الإقامة",
    amenity: {
      air_conditioning: "تكييف الهواء",
      heating: "تدفئة مركزية",
      parking: "موقف سيارات",
      oven: "فرن وموقد",
      pets_allowed: "يُسمح بالحيوانات الأليفة",
      wifi: "إنترنت واي فاي",
      essentials: "الأساسيات",
      washing_machine: "غسالة",
      children_allowed: "يُسمح بالأطفال",
      refrigerator: "ثلاجة",
    },
  },

  amenities: {
    title: "التجهيزات ووسائل الراحة",
    subtitle: "بيّن ما يوفّره مكان إقامتك ليعرف النزلاء ما يمكن توقّعه.",
    searchPlaceholder: "ابحث عن وسيلة راحة…",
    selectedCount:
      "تم تحديد {count} وسيلة راحة | تم تحديد {count} وسائل راحة",
    noResults: "لم يُعثر على وسائل راحة لـ «{search}».",
    cat: {
      all: "الكل",
      basics: "الأساسيات",
      bathroom: "الحمّام",
      bedroom: "غرفة النوم والغسيل",
      kitchen: "المطبخ والطعام",
      outdoor: "الخارج",
      leisure: "الترفيه والتسلية",
      safety: "السلامة",
      family: "العائلات",
      parking: "مواقف السيارات",
      services: "الخدمات",
      connectivity: "الاتصال",
      accessibility: "إمكانية الوصول",
    },
    item: {
      wifi: "واي فاي",
      essentials: "الأساسيات",
      air_conditioning: "تكييف الهواء",
      heating: "تدفئة",
      indoor_fireplace: "مدفأة داخلية",
      hot_water: "ماء ساخن",
      hangers: "علاقات ملابس",
      bed_linen: "مفروشات السرير",
      towels: "مناشف",
      shampoo: "شامبو",
      shower_gel: "جل استحمام",
      conditioner: "بلسم شعر",
      hair_dryer: "مجفّف شعر",
      bathtub: "حوض استحمام",
      bidet: "بيديه",
      jacuzzi: "جاكوزي",
      outdoor_shower: "دش خارجي",
      washing_machine: "غسالة",
      dryer: "مجفّف ملابس",
      iron: "مكواة",
      clothes_drying_rack: "حامل تجفيف الملابس",
      extra_pillows: "وسائد وأغطية إضافية",
      wardrobe: "مساحة لحفظ الملابس",
      blackout_curtains: "ستائر معتمة",
      nearby_laundry: "مغسلة قريبة",
      oven: "فرن",
      refrigerator: "ثلاجة",
      freezer: "مجمّد",
      microwave: "ميكروويف",
      dishwasher: "غسالة أطباق",
      cooking_basics: "أدوات طهي أساسية",
      plates_cutlery: "أطباق وأدوات مائدة",
      wine_glasses: "كؤوس نبيذ",
      coffee_maker: "ماكينة قهوة",
      coffee: "قهوة",
      kettle: "غلاية ماء",
      toaster: "محمّصة خبز",
      blender: "خلاط",
      rice_cooker: "طنجرة أرز",
      bread_maker: "صانعة خبز",
      mini_fridge: "ثلاجة صغيرة",
      stovetop: "موقد",
      dining_table: "طاولة طعام",
      baking_sheet: "صينية خبز",
      bbq_grill: "شواية",
      bbq_utensils: "أدوات شواء",
      outdoor_kitchen: "مطبخ خارجي",
      outdoor_dining: "منطقة طعام خارجية",
      breakfast: "فطور",
      pool: "مسبح",
      shared_pool: "مسبح مشترك",
      garden: "فناء خلفي",
      patio_balcony: "فناء أو شرفة",
      outdoor_furniture: "أثاث خارجي",
      sun_loungers: "كراسي تشمّس",
      hammock: "أرجوحة شبكية",
      fire_pit: "موقد نار خارجي",
      shared_fireplace: "مدفأة في منطقة مشتركة",
      sauna: "ساونا",
      beach_essentials: "أساسيات الشاطئ",
      beach_access: "وصول إلى الشاطئ",
      lake_access: "وصول إلى البحيرة",
      resort_access: "وصول إلى المنتجع",
      waterfront: "على الواجهة المائية",
      dock: "رصيف للقوارب",
      kayak: "كاياك",
      bikes: "دراجات هوائية",
      ski_slope: "منحدر تزلّج",
      outdoor_playground: "ملعب أطفال خارجي",
      tv: "تلفزيون",
      sound_system: "نظام صوت",
      record_player: "مشغّل أسطوانات",
      piano: "بيانو",
      gym: "صالة رياضية",
      exercise_equipment: "أجهزة رياضية",
      games: "ألعاب طاولة",
      giant_games: "ألعاب عملاقة",
      pool_table: "طاولة بلياردو",
      ping_pong: "طاولة تنس طاولة",
      bowling: "صالة بولينغ",
      arcade: "ألعاب أركيد",
      minigolf: "ميني غولف",
      batting_cage: "قفص ضرب الكرة",
      ice_rink: "حلبة هوكي جليد",
      laser_tag: "ليزر تاغ",
      skate_ramp: "منحدر تزلّج بالألواح",
      climbing_wall: "جدار تسلّق",
      game_console: "منصة ألعاب",
      books: "كتب ومواد للقراءة",
      cinema: "سينما",
      themed_room: "غرفة مواضيعية",
      smoke_detector: "كاشف دخان",
      co_detector: "كاشف أول أكسيد الكربون",
      fire_extinguisher: "طفاية حريق",
      first_aid_kit: "حقيبة إسعافات أولية",
      fire_guard: "حاجز مدفأة",
      safe: "خزنة",
      gated_community: "مجمّع سكني مسوّر",
      security_cameras: "كاميرات مراقبة",
      children_allowed: "يُسمح بالأطفال",
      crib: "سرير أطفال",
      travel_cot: "سرير سفر للأطفال",
      baby_bath: "حوض استحمام للرضّع",
      baby_safety_gates: "بوابات أمان للأطفال",
      changing_table: "طاولة تغيير الحفاضات",
      high_chair: "كرسي مرتفع للأطفال",
      children_plates: "أطباق وأدوات مائدة للأطفال",
      children_books_toys: "كتب وألعاب للأطفال",
      kids_bikes: "دراجات للأطفال",
      outlet_covers: "أغطية للمقابس الكهربائية",
      table_corner_guards: "واقيات لزوايا الطاولات",
      window_guards: "واقيات للنوافذ",
      baby_monitor: "جهاز مراقبة الرضّع",
      children_game_room: "غرفة ألعاب للأطفال",
      babysitter_recommendations: "توصيات لجليسات الأطفال",
      parking: "موقف سيارات مجاني في الموقع",
      free_street_parking: "موقف سيارات مجاني في الشارع",
      paid_parking_on_premises: "موقف سيارات مدفوع في الموقع",
      paid_parking_off_premises: "موقف سيارات مدفوع خارج الموقع",
      ev_charger: "شاحن للسيارات الكهربائية",
      e_bike_charger: "شاحن للدراجات الكهربائية",
      pets_allowed: "يُسمح بالحيوانات الأليفة",
      long_term_stays: "متاح للإقامات الطويلة",
      luggage_dropoff: "يُسمح بترك الأمتعة",
      cleaning_during_stay: "تنظيف متاح أثناء الإقامة",
      concierge: "بوّاب",
      cleaning_products: "منتجات تنظيف",
      recycling: "حاويات إعادة تدوير",
      compactor: "ضاغط نفايات",
      compost: "حاوية سماد عضوي",
      solar_panels: "ألواح شمسية",
      workspace: "مساحة عمل",
      private_entrance: "مدخل خاص",
      private_lounge: "صالة خاصة",
      mosquito_net: "ناموسية",
      ceiling_fan: "مروحة سقف",
      portable_fans: "مراوح محمولة",
      ethernet: "اتصال إيثرنت",
      mobile_wifi: "واي فاي متنقل",
      single_floor: "إقامة بطابق واحد",
      elevator: "مصعد",
    },
  },

  room: {
    createTitle: "تسجيل نوع الغرفة",
    editTitle: "تحديث نوع الغرفة",
    namePlaceholder: "مثال: غرفة مزدوجة",
    countLabel: "عدد الغرف من هذا النوع",
    countPlaceholder: "مثال: 20",
    countHint: "يمثّل هذا المخزون الإجمالي للنوع. مثال: «مزدوجة» = 20 غرفة.",
    capacityLabel: "السعة الإجمالية (الحد الأقصى للنزلاء)",
    capacityPlaceholder: "مثال: 5",
    capacityHint:
      "هذا هو الحد الحقيقي للنزلاء. حتى لو وضعت حدوداً قصوى لكل فئة، فالمجموع هو الحاكم.",
    maxAdults: "الحد الأقصى للبالغين",
    maxChildren: "الحد الأقصى للأطفال",
    maxInfants: "الحد الأقصى للرضّع",
    importantLabel: "مهم:",
    capacityNote: "هذه حدود قصوى لكل فئة. المجموع المسموح به تحدده «السعة الإجمالية».",
    physicalTitle: "الغرف الفعلية (RoomInstances)",
    physicalDesc: "فعّله إذا أردت إدارة 101/102 والصيانة لكل غرفة والأقفال.",
    generateLabel: "توليد/ضبط الغرف الفعلية تلقائياً",
    generatorTitle: "مولّد الرموز",
    prefixLabel: "البادئة",
    prefixPlaceholder: "مثال: 10 أو A-",
    prefixHint: "مثال: البادئة «10» + البداية 1 => 101,102...",
    startLabel: "البداية",
    paddingLabel: "الحشو",
    paddingHint: "مثال: حشو 3 => 001,002,003",
    nameModeType: "النوع فقط",
    nameModeTypeCode: "النوع + الرمز",
    defaultDescLabel: "الوصف الافتراضي",
    willCreatePre: "سيتم إنشاء أو ضبط حتى",
    willCreatePost: "غرفة فعلية تلقائياً.",
    errors: {
      saveFallback: "خطأ في حفظ نوع الغرفة.",
      capacityMin: "يجب أن تكون السعة الإجمالية 1 على الأقل.",
      adultsMin: "يجب أن يُسمح ببالغ واحد على الأقل.",
      adultsMax: "لا يمكن أن يكون حد البالغين أكبر من السعة الإجمالية.",
      childrenRange: "يجب أن يكون حد الأطفال بين 0 والسعة الإجمالية.",
      infantsRange: "يجب أن يكون حد الرضّع بين 0 والسعة الإجمالية.",
      roomsMin: "يجب أن يكون عدد الغرف 1 على الأقل.",
      notAuth: "المستخدم غير مُصادَق عليه.",
    },
    toasts: {
      updated: "تم تحديث النوع.",
      created: "تم إنشاء النوع.",
      roomsSynced: "تم توليد/ضبط الغرف الفعلية بنجاح.",
    },
  },

  rate: {
    registerHeader: "تسجيل نوع الغرفة",
    editHeader: "تحديث التعرفة - {name}",
    createHeader: "تسجيل التعرفة - {name}",
    processing: "جارٍ المعالجة، يُرجى الانتظار.",
    general: "عام",
    namePlaceholder: "اسم مخصّص",
    validityLabel: "فترة الصلاحية",
    permanent: "دائم",
    custom: "مخصّص",
    startDatePlaceholder: "تاريخ البداية",
    endDatePlaceholder: "تاريخ النهاية",
    validityNoteCustom: "فترة صلاحية التعرفة (اختياري)",
    validityNotePermanent: "التعرفة صالحة بشكل دائم",
    pricePerNight: "السعر لكل ليلة",
    taxIncluded: "الضرائب مشمولة",
    occupancy: "الإشغال",
    guestsNumber: "عدد النزلاء",
    minStay: "الحد الأدنى للحجز",
    minStayNote: "الحد الأدنى من الليالي للفوترة",
    maxStay: "الحد الأقصى للحجز",
    maxStayNote: "حد الليالي القابلة للحجز",
    errors: {
      rangeRequired: "يجب اختيار نطاق تواريخ صالح",
      startAfterEnd: "لا يمكن أن يكون تاريخ البداية بعد تاريخ النهاية",
      minStay:
        "الحد الأدنى للإقامة هو {minStay} ليالٍ، لكن النطاق المحدَّد يحتوي على {nights} ليالٍ",
    },
  },
};
